import { facilityAction } from 'src/redux/actions/constant';

const { STORE_FACILITY_UUID } = facilityAction;

const initialUuid = '';

export const storeFacilityUuidReducer = (state = initialUuid, action: any) => {
  switch (action.type) {
    case STORE_FACILITY_UUID:
      return action.uuid;

    default:
      return state;
  }
};
